import "../App.css";
import AutoExpandingTextArea from "./AutoExpandingTextArea.tsx";

export default function AddEntry({ value, onChange, onAdd, textareaRef, t }) {
  return (
    <div
      className="container"
      style={{ overflow: "auto", paddingRight: 10, paddingBottom: 10 }}
    >
      <AutoExpandingTextArea
        value={value}
        onChange={onChange}
        textareaRef={textareaRef}
        placeholder={t("write-here")}
        maxLength={280}
      />
      <div
        className="button-primary button-text-l shadow-black text-color-black box-button-center"
        onClick={onAdd}
      >
        {t("add")}
      </div>
    </div>
  );
}
